import * as React from "react";
import { observer, inject } from "mobx-react";
import BootstrapTable from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import { UncontrolledTooltip } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkSquareAlt, faTrash } from "@fortawesome/free-solid-svg-icons";

import NewHorseForSaleDialog from "../horses/NewHorseForSaleDialog";

import { HorseForSale, HorseForSaleStateFriendlyName, HorseForSaleState, SimpleHorseForSale } from "../../model/HorseForSale";

import { HorseStore } from "../../stores/HorseStore";
import { HorseForSaleListStore } from "../../stores/HorseForSaleListStore";
import { HorseForSaleStore } from "../../stores/HorseForSaleStore";
import { ConfigurationStore } from "../../stores/ConfigurationStore";

import { SimpleConfirmation } from "../common/SimpleConfirmAlert";
import { successMessage, errorMessage } from "../common/Toast";

const NONE_ID = -1;

export interface Props {
    horseForSaleListStore?: HorseForSaleListStore;
    horseStore?: HorseStore;
    configurationStore?: ConfigurationStore;
    horseForSaleStore?: HorseForSaleStore;
}

export interface State {
    wasValidated: boolean;
    selectedSale: number;
    isShown: boolean;
}

const EmptyState = (): State => {
    return {
        wasValidated: false,
        selectedSale: NONE_ID,
        isShown: false
    };
};

@inject("horseStore")
@inject("configurationStore")
@inject("horseForSaleListStore")
@inject("horseForSaleStore")
@observer
export default class AddHorseForSale extends React.Component<Props, State> {
    private NewHorseForSaleDialog: NewHorseForSaleDialog | null = null;

    constructor(props: Props) {
        super(props);
        this.state = EmptyState();
    }

    handleDialogHorsesForSale = (): void => {
        if (this.NewHorseForSaleDialog) {
            this.NewHorseForSaleDialog.toggle();
        }
    };

    deleteHorseForSale = (horseForSale: SimpleHorseForSale) => async (event: React.MouseEvent<any>) => {
        event.preventDefault();
        event.stopPropagation();

        try {
            const goAhead = await SimpleConfirmation(`Are you sure you'd like to delete ${horseForSale.horse.name} from ${horseForSale.sale.name}?`);
            /* Please remember that this operation is not reversible. */
            if (!goAhead) {
                return;
            }

            await this.props.horseForSaleListStore!.deleteHorseForSale(horseForSale.id);
            successMessage(`${horseForSale.horse.name} has been deleted from ${horseForSale.sale.name}.`);
            this.props.horseStore!.refresh();
        } catch (error) {
            errorMessage(error);
        }
    };

    render() {
        const columns = [
            {
                dataField: "sale.name",
                text: "Sale"
            },
            {
                dataField: "state",
                text: "State",
                formatter: (state: HorseForSaleState) => HorseForSaleStateFriendlyName(state)
            },
            {
                dataField: "id",
                text: "Actions",
                headerStyle: { width: "80px", textAlign: "center" },
                formatter: (cellContent: HorseForSale, row: any) => {
                    return (
                        <div className="btn-group btn-group-toggle ml-3">
                            <Link
                                to={`/horses-for-sale/${row.id}/application`}
                                className="btn btn-secondary btn-sm"
                                id={`tooltipOpenHFS${row.id}`}
                                title="Open Horse For Sale"
                            >
                                <FontAwesomeIcon icon={faExternalLinkSquareAlt} />
                            </Link>
                            <UncontrolledTooltip placement="top" target={`tooltipOpenHFS${row.id}`} delay={0} className="tooltipstrap">
                                Open Horse For Sale
                            </UncontrolledTooltip>
                            <button
                                onClick={this.deleteHorseForSale(row)}
                                className="btn btn-secondary btn-sm"
                                id={`tooltipDeleteHFS${row.id}`}
                                title="Delete Horse For Sale"
                                disabled={row.referenced}
                            >
                                <FontAwesomeIcon icon={faTrash} />
                            </button>
                            <UncontrolledTooltip placement="top" target={`tooltipDeleteHFS${row.id}`} delay={0} className="tooltipstrap">
                                Delete Horse For Sale
                            </UncontrolledTooltip>
                        </div>
                    );
                }
            }
        ];

        const horseStore = this.props.horseStore!;
        const horse = horseStore.horse;
        if (!horse) {
            return <div />;
        }

        return (
            <div className="card shadow">
                <div className="card-header">
                    <div className="row mr-0">
                        <div className="col-8">Entered Sales</div>
                        <div className="col-4 text-right pr-0 mr-0">
                            <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                data-toggle="button"
                                aria-pressed="false"
                                onClick={this.handleDialogHorsesForSale}
                            >
                                Add Horse for sale
                            </button>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <BootstrapTable
                        keyField="id"
                        bordered={false}
                        bootstrap4={true}
                        striped={true}
                        columns={columns}
                        data={horse.sales}
                        noDataIndication={() => "No selected sales for this horse at the moment."}
                    />
                </div>
                <NewHorseForSaleDialog
                    ref={el => (this.NewHorseForSaleDialog = el)}
                    show={this.state.isShown}
                    horseStore={this.props.horseStore!}
                    configurationStore={this.props.configurationStore!}
                    horseForSaleListStore={this.props.horseForSaleListStore!}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/horses/AddHorseForSale.tsx